import React from "react";
import "../css/contactus.scss";

function Contact() {
  return (
    <main className="main-content" id="MainContent">
      <div className="page-width page-width--narrow page-content">
        <header className="section-header">
          <h1 className="section-header__title">Contact Us</h1>
        </header>
        <div className="rte rte--nomargin">
          <p>
            We're always happy to help. If you have any questions about your
            order, sizing, returns, or anything else, please feel free to reach
            out to us.
          </p>
          <p>
            <strong>1. Email Support</strong>
          </p>
          <p>
            For product, sizing, delivery, return or order questions, email us
            at <strong>core@danecay.shop</strong>. We normally reply within two
            business days, Monday to Friday, Hong Kong time.
          </p>
          <p>
            <strong>2. What to Include</strong>
          </p>
          <p>
            Include your order number, the email used at checkout and a short
            description of the issue. For a damaged or incorrect item, attach
            clear photos of the product, packaging and shipping label.
          </p>
          <p>
            <strong>3. Business Address</strong>
          </p>
          <p>
            danecay Customer Care<br />
            Av. del Marques 25, Rincones del marques, 76246 Santiago de Querétaro, Qro., MX
          </p>
          <p>
            Please contact us before sending a return. Parcels sent without an
            approved return request may not be identified or processed.
          </p>
          <p>
            <strong>4. Official Store</strong>
          </p>
          <p>
            This website is the official online store for danecay. We do not
            list social-media accounts unless they are operated and verified by
            our team.
          </p>
        </div>
      </div>
    </main>
  );
}

export default Contact;
